var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images)?_c('progressive-background',{staticClass:"bg",attrs:{"src":this.setRandomImage(),"blur":6},scopedSlots:_vm._u([{key:"content",fn:function({ visible }){return _c('div',{staticClass:"home-content"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Outdoors | Photography | Sports ")])])])}}],null,false,3031721663)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }